import { Injectable } from '@angular/core';
import { HttpError } from '../models/errors/HttpError';
import { IBaseResponse } from '../models/comm-http/responses/BaseResponse';
import { HttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { KeyValuePair } from 'app/models/KeyValuePair';
import { Router } from '@angular/router';

@Injectable()
export class CommHttpService {

    // router public because it is used in other classes
    constructor(private httpMain: HttpClient, private router: Router) {
    }

    private StatusCodeToFriendlyMessage(code: number, defaultValue: string = ''): string {

        switch (code) {

            case 401:
                return 'Wrong username or password!';

            default:
                return defaultValue;
        }

    }

    private ErrorToFriendlyMessage(response: HttpResponse<any>): string {

        // check first error in header
        let headerKeys = response.headers.keys();

        // headers?
        if (!headerKeys) {
            // return from status
            return this.StatusCodeToFriendlyMessage(response.status, response.statusText);
        }

        // check from headers
        if (headerKeys.some(x => x === 'autherrorcode')) {
            let code = response.headers.get('autherrorcode');

            switch (code) {

                case '0':
                    return response.headers.get('autherror');

                case '1':
                    return 'Wrong Username or Password';

                default:
                    // return from status
                    return this.StatusCodeToFriendlyMessage(response.status, response.statusText);
            }

        }

    }


    private HandleError(error: HttpResponse<any>): Observable<any> {

        // let errorResponse: any;

        // if (error.status === 0)
        //     errorResponse = new HttpNoConnectionError(error);

        // else if (error.status === 401)
        //     errorResponse = new HttpUnauthorized(error);

        // else if (error.status === 403)
        //     errorResponse = new HttpForbidden(error);

        // else if (error.status === 404)
        //    errorResponse = new HttpNotFoundError(error);

        //  else if (error.status === 400)
        //     errorResponse = new BadRequest(error.json());

        //  else
        let errorResponse = new HttpError(error);
        errorResponse.FriendlyTitle = 'Error';

        if (error.status == 0) {
            errorResponse.FriendlyTitle = 'Connection Error';
            errorResponse.FriendlyMessage = 'Unable to connect to server.';
        } else if (error.status == 401) {
            localStorage.clear();
            this.router.navigate(['/authentication/signin']);
        } else {
            errorResponse.FriendlyMessage = error.statusText;
        }


        return throwError(errorResponse);

    }

    protected Post<T>(url: string, data: any, headers: HttpHeaders = null, withCredentials: boolean = true): Observable<IBaseResponse<T>> {

        let reqHeaders: HttpHeaders = headers ? headers : new HttpHeaders();

        return this.httpMain.post<any>(url, data, { headers: reqHeaders, withCredentials: withCredentials })
            .pipe(
            catchError(
                (error) => {

                    // if ((error as Response).status == 401)
                    //   this.onAuthError.next(error.statusText);

                    return this.HandleError(error);
                })
            );
    }

    protected PostRaw(url: string, data: any, headers: HttpHeaders = null, withCredentials: boolean = true): Observable<any> {

        let reqHeaders: HttpHeaders = headers ? headers : new HttpHeaders();

        return this.httpMain.post(url, data, { headers: reqHeaders, withCredentials: withCredentials })
            .pipe(
                catchError(
                    (error) => {

                        // if ((error as Response).status == 401)
                        //   this.onAuthError.next(error.statusText);
    
                        return this.HandleError(error);
                })
            );
    }


    protected Patch<T>(url: string, data: any, headers: HttpHeaders = null): Observable<IBaseResponse<T>> {

        let reqHeaders: HttpHeaders = headers ? headers : new HttpHeaders();

        return this.httpMain.patch(url, data, { headers: reqHeaders, withCredentials: true })
            .pipe(
                catchError(
                    (error) => {

                        // if ((error as Response).status == 401)
                        //   this.onAuthError.next(error.statusText);
    
                        return this.HandleError(error);
                    })
                );
    }


    protected Delete<T>(url: string, headers: HttpHeaders = null): Observable<IBaseResponse<T>> {

        let reqHeaders: HttpHeaders = headers ? headers : new HttpHeaders();
        let qData = '';


        return this.httpMain.delete(url, { headers: reqHeaders, withCredentials: true })
        .pipe(
            catchError(
                (error) => {

                    // if ((error as Response).status == 401)
                    //    this.onAuthError.next(error.statusText);

                    return this.HandleError(error);
                })
            );

    }

    protected GetCore<T>(converter: any, url: string, queryData: KeyValuePair<string, string>[] = null, headers: HttpHeaders = null): Observable<IBaseResponse<T>> {

        let reqHeaders: HttpHeaders = headers ? headers : new HttpHeaders();
        let qData = '';

        if (queryData != null) {
            qData = '?';
            for (let item of queryData) {
                qData += item.Key + '=' + item.Value;
            }
        }

        return this.httpMain.get(url, { headers: reqHeaders, withCredentials: true })
            .pipe(
                map((response: HttpResponse<any>) => {

                    return converter(response);

                }),
                catchError((error) => {

                    // if ((error as Response).status == 401)
                    //  this.onAuthError.next(error.statusText);

                    return this.HandleError(error);
                })
            );

    }

    protected Get<T>(url: string, queryData: KeyValuePair<string, string>[] = null, headers: HttpHeaders = null): Observable<IBaseResponse<T>> {

        // only properties

        let converter =
            function (response: HttpResponse<any>) {
                return response;
            };

        return this.GetCore<T>(converter, url, queryData, headers);
    }

}
